import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { WpgSpaceFragment } from '@api/fragments'
import { IWorkplaceGroupSpace } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  deleteWorkplaceGroupsFromSpace: {
    spaces: IWorkplaceGroupSpace[]
  }
}

const mutateHandler = handleFetchResult<IPayload, IWorkplaceGroupSpace[]>({
  handler: (data) => data.deleteWorkplaceGroupsFromSpace.spaces,
  name: 'Spaces',
})

export const unAssignSpacesFromWorkplaceGroupMutation = gql`
  mutation DeleteWorkplaceGroupsFromSpace($input: DeleteWorkplaceGroupsFromSpaceInput!) {
    deleteWorkplaceGroupsFromSpace(input: $input) {
      spaces {
        ...WpgSpaceFragment
      }
    }
  }
  ${WpgSpaceFragment}
`
export default function unAssignSpacesFromWorkplaceGroup(
  workplaceGroupIds: string[],
  spaceId: string
): Promise<IWorkplaceGroupSpace[]> {
  const input = { workplaceGroupIds, spaceId }

  return client.gql
    .mutate({
      mutation: unAssignSpacesFromWorkplaceGroupMutation,
      variables: { input },
    })
    .then(mutateHandler)
}
